import { actions } from '../constants/cms_lightbox/actions';
import Dispatcher from '../dispatcher';

export const show = () =>
    Dispatcher.handleCmsLightboxAction({ type: actions.SHOW });

export const hide = () =>
    Dispatcher.handleCmsLightboxAction({ type: actions.HIDE });

export const setHeadline = (headline) =>
    Dispatcher.handleCmsLightboxAction({ type: actions.SET_HEADLINE, payload: headline });

export const setSubHeadline = (subHeadline) =>
    Dispatcher.handleCmsLightboxAction({ type: actions.SET_SUB_HEADLINE, payload: subHeadline });

export const setFooterText = (footerText) =>
    Dispatcher.handleCmsLightboxAction({ type: actions.SET_FOOTER_TEXT, payload: footerText });

export const setFooterCloseText = (footerCloseText) =>
    Dispatcher.handleCmsLightboxAction({ type: actions.SET_FOOTER_CLOSE_TEXT, payload: footerCloseText });
